import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-base font-bold text-gray-900 dark:text-white mb-3">{title}</h2>
    <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2 leading-relaxed">{children}</div>
  </div>
);

export default function Terms() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 mb-6"
        >
          <ChevronLeft className="w-4 h-4" /> 뒤로가기
        </button>

        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">이용약관</h1>
        <p className="text-xs text-gray-400 mb-8">시행일: 2026년 3월 20일</p>

        <Section title="제1조 (목적)">
          <p>이 약관은 티앤티 주식회사(이하 "회사")가 운영하는 Gym Manager 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
        </Section>

        <Section title="제2조 (정의)">
          <p>① "서비스"란 회사가 제공하는 헬스장 회원 관리 웹 애플리케이션 Gym Manager를 말합니다.</p>
          <p>② "이용자"란 이 약관에 따라 서비스에 접속하여 회사가 제공하는 서비스를 이용하는 자를 말합니다.</p>
          <p>③ "관리자 계정"이란 헬스장을 운영하는 사업자가 서비스를 관리·운영하기 위해 사용하는 계정을 말합니다.</p>
          <p>④ "회원 계정"이란 헬스장에 등록된 회원이 자신의 이용 현황을 확인하기 위해 사용하는 계정을 말합니다.</p>
        </Section>

        <Section title="제3조 (약관의 효력 및 변경)">
          <p>① 이 약관은 서비스 화면에 게시하거나 기타의 방법으로 공지함으로써 효력이 발생합니다.</p>
          <p>② 회사는 필요한 경우 관련 법령을 위반하지 않는 범위에서 이 약관을 변경할 수 있으며, 변경된 약관은 공지 후 효력이 발생합니다.</p>
          <p>③ 이용자는 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 계정을 해지할 수 있습니다.</p>
        </Section>

        <Section title="제4조 (서비스의 제공 및 변경)">
          <p>① 회사는 다음과 같은 서비스를 제공합니다.</p>
          <p className="pl-4">1. 헬스장 회원 등록 및 관리</p>
          <p className="pl-4">2. 회원권 및 PT 관리</p>
          <p className="pl-4">3. 출석 및 매출 관리</p>
          <p className="pl-4">4. 회원 포털(회원 앱) 서비스</p>
          <p className="pl-4">5. 기타 회사가 정하는 서비스</p>
          <p>② 회사는 서비스의 내용을 변경하거나 중단할 수 있으며, 이 경우 사전에 공지합니다.</p>
        </Section>

        <Section title="제5조 (서비스 이용 신청 및 승인)">
          <p>① 서비스 이용을 원하는 자는 회사가 정한 절차에 따라 가입을 신청합니다.</p>
          <p>② 회사는 가입 신청에 대해 승인을 원칙으로 하되, 다음 각 호에 해당하는 경우 승인을 거부하거나 취소할 수 있습니다.</p>
          <p className="pl-4">1. 실명이 아니거나 타인의 정보를 사용한 경우</p>
          <p className="pl-4">2. 허위 정보를 기재한 경우</p>
          <p className="pl-4">3. 관련 법령에 위배되는 경우</p>
        </Section>

        <Section title="제6조 (이용자의 의무)">
          <p>이용자는 다음 행위를 하여서는 안 됩니다.</p>
          <p className="pl-4">1. 타인의 정보 도용</p>
          <p className="pl-4">2. 회사가 게시한 정보의 무단 변경</p>
          <p className="pl-4">3. 서비스를 이용하여 얻은 정보를 회사의 사전 동의 없이 복제·유통·이용하는 행위</p>
          <p className="pl-4">4. 회사 및 제3자의 지적재산권을 침해하는 행위</p>
          <p className="pl-4">5. 관련 법령 또는 약관을 위반하는 행위</p>
        </Section>

        <Section title="제7조 (계정 관리)">
          <p>① 이용자는 자신의 계정과 비밀번호를 철저히 관리할 책임이 있습니다.</p>
          <p>② 이용자는 계정을 제3자에게 양도·대여할 수 없습니다.</p>
          <p>③ 계정 도용 등 보안 사고 발생 시 즉시 회사에 통보해야 합니다.</p>
        </Section>

        <Section title="제8조 (서비스 중단)">
          <p>① 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 등의 사유가 발생한 경우 서비스의 제공을 일시적으로 중단할 수 있습니다.</p>
          <p>② 회사는 전항의 사유로 발생한 손해에 대하여 이용자에게 별도의 보상을 하지 않습니다. 단, 회사의 고의 또는 중대한 과실로 인한 경우는 제외합니다.</p>
        </Section>

        <Section title="제9조 (면책 조항)">
          <p>① 회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중지 등 불가항력적인 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.</p>
          <p>② 회사는 이용자의 귀책사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.</p>
          <p>③ 회사는 이용자가 서비스를 통해 얻은 정보에 관하여 손해가 발생하거나 이용자 상호 간 분쟁이 발생한 경우 책임을 지지 않습니다.</p>
        </Section>

        <Section title="제10조 (분쟁 해결)">
          <p>① 서비스 이용과 관련하여 발생한 분쟁에 대해 소송이 제기될 경우 회사의 소재지를 관할하는 법원을 전속 관할 법원으로 합니다.</p>
          <p>② 이 약관에 관한 문의는 아래 연락처로 문의하시기 바랍니다.</p>
        </Section>

        <div className="mt-8 p-4 bg-gray-100 dark:bg-gray-800 rounded-xl text-sm text-gray-600 dark:text-gray-400 space-y-1">
          <p className="font-medium text-gray-900 dark:text-white">티앤티 주식회사 (TNT Inc.)</p>
          <p>충북 충주시 호암토성2로3, 707호 (27480)</p>
          <p>사업자등록번호: 105-88-17712</p>
          <p>이메일: ezbiz.manager@gmail.com</p>
        </div>
      </div>
    </div>
  );
}
